import { Dropdown } from 'antd'

export const DropdownButton = (props: any) => {
  return <Dropdown.Button {...props}>{props.children}</Dropdown.Button>
}
